import { Collapse } from '@mui/material';
import { useField } from 'react-final-form';

import { AwardMultipleSelect, Switches } from '@occc-app/design-system';
import {
  CardContent,
  CardHeader,
  IconAvatar,
  LibraryAddCheckOutlinedIcon,
  Paper,
  Typography,
} from '@occc/ui-design-system';

import {
  defaultFieldNamePrefix,
  defaultConstraintEnabledFieldName,
  defaultConstraintAwardsFieldName,
} from './award-restrictions.constants';

export type AwardRestrictionsProps = {
  fieldNamePrefix?: string;
  constraintIsEnabledFieldName?: string;
  constraintAwardsFieldName?: string;
};

export const AwardRestrictions = (props: AwardRestrictionsProps) => {
  const {
    fieldNamePrefix = defaultFieldNamePrefix,
    constraintIsEnabledFieldName = defaultConstraintEnabledFieldName,
    constraintAwardsFieldName = defaultConstraintAwardsFieldName,
  } = props;

  const isEnabledFieldName = `${fieldNamePrefix}.${constraintIsEnabledFieldName}`;
  const awardsFieldName = `${fieldNamePrefix}.${constraintAwardsFieldName}`;
  const isEnabledField = useField(isEnabledFieldName);

  return (
    <Paper>
      <CardHeader
        title={<Typography variant='subtitle1'>Award Restrictions</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            Member cannot receive this award if they already hold any of the following awards
          </Typography>
        }
        action={<Switches name={isEnabledFieldName} data={{}} />}
        avatar={<IconAvatar Icon={LibraryAddCheckOutlinedIcon} />}
        sx={{ py: 2, px: 3 }}
      />
      <Collapse in={Boolean(isEnabledField.input.value)} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <AwardMultipleSelect name={awardsFieldName} />
        </CardContent>
      </Collapse>
    </Paper>
  );
};
